import { useNavigate } from 'react-router';
import btnlogin from './images/btnlogin.png';
import logo from './images/logo.png';
import axios from 'axios';
import { connect } from 'react-redux';
import { setLogin } from './action';
function Login({commondata,setLogin})
{
    let nav=useNavigate();
    function checklogin(event)
    {
        event.preventDefault();
        let s1=document.getElementById("t1").value;
        let s2=document.getElementById("t2").value;
        let json=JSON.stringify({ulogin:s1,upass:s2});
        let config={headers:{"Content-Type":"application/json",}};
        axios.post(process.env.REACT_APP_APIURL+"users.php?opr=C",json).then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")
            {
                window.ulogin=reply.data.data.ulogin;
                window.urole=reply.data.data.urole;
                window.uname=reply.data.data.fullname;
                document.getElementById("t1").value="";
                document.getElementById("t2").value="";
                setLogin("Y");
                nav("/dashboard");
            }
            else
            {
                alert(reply.data.message);
            }
        });        
    }
    return(
        <div className="container">
            <div className="row mt-2">
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-2 col-sm-1 col-12"></div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-8 col-sm-10 col-12 text-center">
                    <img src={logo} className='w-25' />
                </div>
                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-2 col-sm-1 col-12"></div>

                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-2 col-sm-1 col-12"></div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-8 col-sm-10 col-12 p-3">
                    <div className="card shadow">
                        <div className="card-header text-center h5 bg-success text-white">Member Authentication</div>
                        <div className="card-body">
                            <form onSubmit={checklogin}>
                                <div className="form-group">
                                    <label>Login</label>
                                    <input type="text" id="t1" className="form-control" required />
                                </div>
                                <div className="form-group">
                                    <label>Password</label>
                                    <input type="password" id="t2" className="form-control" required />
                                </div>
                                <input type="image" className='mt-3' style={{width:'150px'}} src={btnlogin} />
                            </form>
                        </div>
                    </div>
                </div>
                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-2 col-sm-1 col-12"></div>                
            </div>
        </div>
    );
}
let connectToStore=(state)=>({commondata:state});
let dispatchToStore=(dispatch)=>(
    {
        setLogin:(value)=>dispatch(setLogin(value)),
    }
);
export default connect(connectToStore,dispatchToStore)(Login);